import {CLOSE_DIALOG, OPEN_DIALOG} from '../actions/dialog';
import {RESET_STATE} from "../actions/root";

const INITIAL_STATE = {
    dialog: '',
    onAction: null,
};

const dialog = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case OPEN_DIALOG:
            return {
                ...state,
                dialog: action.dialog,
                onAction: action.onAction,
            };
        case CLOSE_DIALOG:
            return {
                ...state,
                dialog: '',
                onAction: null
            };
        case RESET_STATE:
            return INITIAL_STATE;
        default:
            return state;
    }
};
export default dialog;
